import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LanguageSelectorComponent } from '../../language-selector/language-selector.component';
import { ProfileMenuComponent } from '../../profile-menu/profile-menu.component';
import { UtilitiesService } from '../../../services/utilities.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-aow-header',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        LanguageSelectorComponent,
        ProfileMenuComponent,
    ],
    templateUrl: './aow-header.component.html',
    styleUrl: './aow-header.component.scss',
})
export class AowHeaderComponent implements OnInit {
    isDarkMode = false;
    isUniqueClient = false;
    companyName = '';
    clientId: number | null = null;

    constructor(public utilities: UtilitiesService, private router: Router) { }

    ngOnInit(): void {
        this.isUniqueClient = this.utilities.isUniqueClientValue;
        this.companyName = this.utilities.companyNameValue;
        this.clientId = this.utilities.clientId;

        const savedTheme = localStorage.getItem('theme');
        if (savedTheme === 'theme-dark') {
            this.isDarkMode = true;
            this.applyTheme('theme-dark');
        } else {
            this.isDarkMode = false;
            this.applyTheme('light-theme');
        }
    }

    redirectSelectClient(): void {
        if (this.isUniqueClient) return;
        this.utilities.setIsUniqueClient(null);
        this.router.navigate(['select-client']);
    }

    toggleTheme(): void {
        this.isDarkMode = !this.isDarkMode;
        this.applyTheme(this.isDarkMode ? 'theme-dark' : 'light-theme');
    }

    private applyTheme(theme: string): void {
        if (theme === 'theme-dark') {
            document.body.classList.remove('light-theme');
            document.body.classList.add('theme-dark');
        } else {
            document.body.classList.remove('theme-dark');
            document.body.classList.add('light-theme');
        }
        localStorage.setItem('theme', theme);
    }
}
